import React from "react";
import { Glyphicon } from "react-bootstrap";
import { useUtilityStyles } from "../hooks/useUtilityStyles";
import { classNames } from "../utils/classNames";
import { useModalTitleClasses } from "./Title.styles";
export var TYPE_GLYPHS = {
    info: "info-sign",
    warning: "exclamation-sign",
    warningWithoutCancel: "exclamation-sign",
    success: "ok",
    error: "remove-sign",
};
export var Title = function (_a) {
    var type = _a.type, title = _a.title, titleType = _a.titleType, styleOptions = _a.styleOptions;
    var TitleElement = titleType === "header" ? "h1" : "span";
    var classes = useModalTitleClasses(type, titleType === "span");
    var utilityStyles = useUtilityStyles(styleOptions);
    return (React.createElement("div", { className: classNames(utilityStyles.utilities, classes.wrapper) },
        type && React.createElement(Glyphicon, { className: classes.icon, glyph: TYPE_GLYPHS[type] }),
        React.createElement(TitleElement, { className: classes.title, "data-hook": "modal-title" }, title)));
};
